(function () {
  function init(section) {
    if (!section || section.dataset.testimonialsReady === 'true') return;
    section.dataset.testimonialsReady = 'true';
    var track = section.querySelector('[data-testimonials-track]');
    if (!track) return;
    var videos = Array.prototype.slice.call(section.querySelectorAll('video'));

    function pauseOthers(active) {
      videos.forEach(function (video) {
        if (video !== active && !video.paused) video.pause();
      });
    }

    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        pauseOthers(video);
        var card = video.closest('.barefoot-testimonial');
        if (card) card.classList.add('is-playing');
      });
    });

    section.querySelectorAll('[data-testimonial-play]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('.barefoot-testimonial');
        var video = card && card.querySelector('video');
        if (!video) return;
        pauseOthers(video);
        video.controls = true;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      });
    });

    function move(direction) {
      var card = track.querySelector('.barefoot-testimonial');
      var distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * .85;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
    var previous = section.querySelector('[data-testimonials-prev]');
    var next = section.querySelector('[data-testimonials-next]');
    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-barefoot-testimonials]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
